export const brandColors = {
  brandOne: '#005950',
  brandTwo: '#A3E953',
  brandThree: '#D2B470',
} as const;
